import { render, staticRenderFns } from "./CourseBaseInfo.vue?vue&type=template&id=65920e79&"
import script from "./CourseBaseInfo.vue?vue&type=script&lang=js&"
export * from "./CourseBaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports